import * as h from "../helpers/helpers";
import * as rf from "./reportFunctions";
import * as ri from "./rentalInformationFunctions"
import * as scf from "./salesComparisonFunctions";
import * as iaf from "./incomeApproachFunctions";
import * as caf from "./costApproachFunctions";

export function lu(fId) {
	var tf = false;
	var value = undefined;

	if (!global.ptr.pointersLoaded) return value;

	try {
	// semi-global variables
		var dwelling = (global.ptr.dwelling) ? global.ptr.dwelling : global.ptr.subDwelling;
		var dwDetail = dwelling.improvementDetail;
		var mh = dwelling.manufacturedHome;
		var mhDetail = mh !== null ? mh.manufacturedHomeDetail : null;
		var propertyUnit = global.ptr.propertyUnit;
		var unitDetail = propertyUnit.propertyUnitDetail;
		var unitArea = propertyUnit.propertyUnitArea;
	} catch (err) {
		let msg = "Trap in lu() init section: " + err;
		console.log(msg);
		alert(msg);
		return value;
	}
	//console.log(propertyUnit,unitDetail,unitArea);
	
	try {
	switch (fId) {
		case "1.000":
			value = global.ptr.subProp.address.GetFullAddress();
			value = value.replace('\n', ', ').toUpperCase();
			break;
		case "1.001":
			value = h.amountOrEmpty(global.ptr.valSumDetail.opinionOfValueAmount);
			break;
		case "1.002":
			if (!global.ptr.valRecon.ConditionalConclusionExists("AsIs"))
				value = global.ptr.valRecon.GetFinalValueConditionStatement();
			break;
		case "1.003":
			value = global.ptr.valSumDetail.appraisalReportEffectiveDate.FormatMDY();
			break;
		case "1.004":
			value = global.ptr.sowDetail.valuationAssignmentType;
			break;
		case "1.005":
			value = global.ptr.parties.GetNamesOfPartiesOfRole("Borrower");
			break;
		case "1.006":
			value = global.ptr.parties.GetPropertyOwnerName();
			break;
		case "1.007":
			value = h.amountOrEmpty(global.ptr.subSales.GetContractAmount());
			break;
		case "1.008":
			value = global.ptr.subProp.GetListingStatus();
			break;
		case "1.009":
			value = global.ptr.valRecon.GetValuationConditionsList();
			//console.log("1.009: ", value);
			break;
		case "1.010":
			value = h.toEnumText(global.ptr.subProp.propertyValuationMethodType);
			break;
		case "1.011":
			value = global.ptr.parties.GetNamesOfPartiesOfRole("Appraiser");
			break;
		case "1.012":
			value = dwelling.structure.GetConstructionMethodsList();
			//console.log("1.012: ", value);
			break;
		case "1.013":
			value = global.ptr.subDetail.attachmentType;
			break;
		case "1.014":
			value = dwelling.structure.GetStructuralDesignType();
			break;
		case "1.015":
			tf = global.ptr.subDetail.PUDIndicator;
			value = tf ? "Y" : "N";
			break;
		case "1.016":
			tf = global.ptr.bCondominium;
			value = tf ? "Y" : "N";
			break;
		case "1.017":
			tf = global.ptr.bCooperative;
			value = tf ? "Y" : "N";
			break;
		case "1.018":
			tf = global.ptr.bCondop;
			value = tf ? "Y" : "N";
			break;
		case "1.019":
			value = global.ptr.subSite.siteDetail.siteDefectsExistIndicator ?? false;
			break;
		case "1.020":
			value = global.ptr.bOwnedInCommon;
			break;
		case "1.021":
			value = global.ptr.subDetail.livingUnitExcludingADUCount.toString();
			break;
		case "1.022":
			value = global.ptr.subDetail.accessoryDwellingUnitTotalCount.toString();
			break;
		case "1.023":
			value = global.ptr.subProp.GetEstateType();
			break;
		case "1.024":
			tf = global.ptr.subSite.highestAndBestUse.siteHighestBestUseIndicator;
			value = tf ? "Y" : "N";
			//console.log("1.024: ", value);
			break;
		case "1.025":
			value = global.ptr.subProp.GetPropertyRestrictions();
			break;
		case "1.026":
			value = global.ptr.subProp.GetEncroachments();
			break;
		case "1.027":
			value = h.toEnumText(global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningComplianceType);
			break;
		case "1.028":
			value = "";
			if (mhDetail)
				value = h.yesNo(mhDetail.manufacturedHomeHUDDataPlateAttachedIndicator);
			break;
		case "1.029":
			value = "";
			if (mhDetail)
				value = h.yesNo(mhDetail.manufacturedHomeHUDCertificateLabelIndicator);
			break;
		case "1.030":
			value = global.ptr.subDetail.overallQualityRatingCode;
			break;
		case "1.031":
			value = global.ptr.subDetail.overallConditionRatingCode;
			break;
		case "1.082":
			value = global.ptr.valSumDetail.propertyAsIsConditionRatingCode;
			break;
		case "1.083":
			break;
		case "2.000":
			value = global.ptr.sowDetail.valuationAssignmentType
			break;
		case "2.001":
			value = global.ptr.parties.GetNamesOfPartiesOfRole("Borrower");
			break;
		case "2.002":
			value = global.ptr.parties.GetNamesOfPartiesOfRole("PropertySeller");
			break;
		case "2.003":
			value = global.ptr.parties.GetPropertyOwnerName();
			break;
		case "2.004":
			value = h.toEnumText(global.ptr.subProp.propertyValuationMethodType);
			break;
		case "2.005":
			value = global.ptr.valDetail.propertyDataReportIndicator ?? false;
			break;
		case "2.006":
			value = global.ptr.parties.GetFee("AppraisalFee");
			break;
		case "2.007":
			value = global.ptr.parties.GetFee("AppraisalManagementCompanyFee");
			break;
		case "2.008":
			value = global.ptr.bGovAgency
			break;
		case "2.009":
			value = global.ptr.valDetail.investorRequestedIdentificationIndicator ?? false;
			break;
		case "2.010":
			value = global.ptr.valDetail.investorRequestedIdentificationIndicator ?? false;
			break;
		case "2.011":
			value = global.ptr.valDetail.investorRequestedIdentificationIndicator ?? false;
			break;
		case "2.061":
			value = global.ptr.valRpt.GetValuationCommentaryText("Assignment");
			break;
		case "3.000":
			value = global.ptr.subProp.address.GetFullAddressList()
			break;
		case "3.001":
			value = global.ptr.subProp.GetAltAddresses()
			break;
		case "3.002":
			value = global.ptr.subProp.address.countyName;
			break;
		case "3.003":
			value = global.ptr.subProp.neighborhood.neighborhoodDetail.neighborhoodName;
			break;
		case "3.004":
			value = global.ptr.subDetail.attachmentType;
			break;
		case "3.005":
			value = global.ptr.subDetail.livingUnitExcludingADUCount.toString();
			break;
		case "3.006":
			value = global.ptr.subDetail.accessoryDwellingUnitTotalCount.toString();
			break;
		case "3.007":
			value = global.ptr.subDetail.livingUnitExcludingADUCount > 1 ? global.ptr.subDetail.dwellingCount.toString() : "";
			break;
		case "3.008":
			value = h.yesNo(global.ptr.subTax.propertyTaxDetail.specialTaxAssessmentsIndicator);
			break;
		case "3.009":
			value = global.ptr.valRpt.GetValuationCommentaryText("PropertySpecialTaxAssessments");
			break;
		case "3.010":
			value = global.ptr.subDetail.PUDIndicator;
			break;
		case "3.011":
			value = global.ptr.bCondominium;
			break;
		case "3.012":
			value = global.ptr.bCooperative;
			break;
		case "3.013":
			value = global.ptr.bCondop;
			break;
		case "3.014":
			value = global.ptr.subDetail.nativeAmericanLandsIndicator;
			break;
		case "3.015":
			value = global.ptr.bOwnedInCommon;
			break;
		case "3.016":
			value = global.ptr.subDetail.homeownerResponsibleForExteriorMaintenanceIndicator
			break;
		case "3.017":
			value = global.ptr.subDetail.newConstructionIndicator;
			break;
		case "3.018":
			value = global.ptr.subProp.GetConstructionStatus();
			//console.log("3.018: ", value);
			break;
		case "3.019":
			value = global.ptr.subProp.GetEstateType();
			break;
		case "3.020":
			value = "";
			if (global.ptr.bLeasehold)
				value = h.yesNo(global.ptr.subDetail.communityLandTrustIndicator);
			break;
		case "3.021":
			value = global.ptr.subProp.GetNativeAmericanLandsType();
			if (value === "No") value = "";
			break;
		case "3.022":
			value = "";
			if (global.ptr.bGroundRent)
				value = h.amountOrEmpty(global.ptr.subProp.propertyGroundRent?.propertyGroundLeaseAnnualAmount);
			break;
		case "3.023":
			value = "";
			if (global.ptr.bGroundRent)
				value = h.yesNo(global.ptr.subProp.propertyGroundLeaseRenewableIndicator);
			break;
		case "3.024":
			value = "";
			if (global.ptr.bGroundRent)
					value = global.ptr.subProp.propertyGroundRent?.propertyGroundLeaseTermYearsCount?.toString();
			//console.log("3.024: ", value);
			break;
		case "3.025":
			value = "";
			if (global.ptr.bGroundRent)
				value = global.ptr.subProp.propertyGroundRent?.propertyGroundLeaseExpirationDate.FormatMDY();
			break;
		case "3.026":
			value = "";
			if (global.ptr.bGroundRent)
				value = global.ptr.subProp.propertyGroundRent?.propertyGroundRentDescription;
			break;
		case "3.027":
			value = "";
			if (!global.ptr.bOwnedInCommon)
				value = h.yesNo(global.ptr.bRightsAppraised);
			break;
		case "3.028":
			value = "";
			if (!global.ptr.bRightsAppraised)
					value = global.ptr.subProp.GetRightsNotIncluded();
			break;
		case "3.029":
			value = h.yesNoIf(global.ptr.subDetail.mineralRightsLeasedIndicator, !global.ptr.bRightsAppraised);
			break;
		case "3.030":
			value = "";
			if (global.ptr.bGovAgency && !global.ptr.subProp.GetAppraisedIndicator() && (global.ptr.bRightsAppraised && !global.ptr.subProp.GetRightsNotIncluded().includes("Mineral Rights")));
				value = global.ptr.sowDetail.propertyRightsNotAppraisedDescription;
			break;
		case "3.031":
			value = global.ptr.subProp.parcelSummary.parcelSummaryDetail.parcelsLegalDescription;
			break;
		case "3.032":
			value = global.ptr.valRpt.GetValuationCommentaryText("SubjectProperty");
			break;
		case "3.033":
			break;
		case "3.034":
			break;
		case "3.035":
			break;
		case "3.036":
			break;
		case "3.037":
			break;
		case "3.038":
			break;
		case "3.039":
			break;
		case "4.000":
			value = global.ptr.subSite.siteSizeLayout?.lotSizeAreaMeasure.ToString();
			break;
		case "4.001":
			value = global.ptr.subSite.siteSizeLayout?.siteDimensionsDescription;
			break;
		case "4.002":
			value = global.ptr.subProp.site.siteSizeLayout?.parcelCount.toString();
			break;
		case "4.003":
			var pcgt1 = global.ptr.subProp.site.siteSizeLayout?.parcelCount > 1;
			value = h.yesNoIf(global.ptr.subProp.site.siteSizeLayout?.parcelsContiguousIndicator, pcgt1);
			break;
		case "4.004":
			value = global.ptr.subProp.parcelSummary.GetElementsDividingParcels();
			break;
		case "4.005-07":
			value = [];
			for (var p of global.ptr.subProp.parcels) {
				value.push(p.GetAPNInfo());
			}
			break;
		case "4.008":
			var complianceType = global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningComplianceType;
			value = h.toEnumText(complianceType);
			break;
		case "4.009":
			if (complianceType !== "NoZoning")
				value = global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningClassificationIdentifier;
			break;
		case "4.010":
			if (complianceType !== "NoZoning")
				value = global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningClassificationDescription;
			break;
		case "4.011":
			if (complianceType === "Illegal")
				value = global.ptr.subSite.siteZoning.GetIllegalReasons();
			break;
		case "4.012":
			value = global.ptr.valRpt.GetValuationImpact("ZoningCompliance");
			if (!value)
				value = global.ptr.valRpt.GetValuationImpact("ValueMarketabilityImpactType");
			break;
		case "4.013":
			if (complianceType === "LegalNonconforming")
				value = h.yesNo(global.ptr.subSite.siteZoning.siteZoningDetail.zoningPermitRebuildToCurrentDensityIndicator);
			break;
		case "4.014":
			value = global.ptr.subSite.siteZoning.siteZoningDetail.siteZoningComplianceDescription;
			break;
		case "4.015":
			if (global.ptr.bMixedUsage)
				value = h.yesNo(global.ptr.subProp.propertyUseSummary?.propertyPrimarilyResidentialUseIndicator);
			break;
		case "4.016":
			if (global.ptr.bMixedUsage)
				value = global.ptr.subProp.propertyUseSummary?.residentialUsePercent;
			break;
		case "4.017":
			if (!global.ptr.bMixedUsage)
      	value = "None";
			else
				value = global.ptr.subProp.GetNonResidentialUses();
			break;
		case "4.018":
			if (global.ptr.bMixedUsage)
				value = h.yesNone(global.ptr.subProp.propertyUseSummary?.nonResidentialModificationIndicator);
			break;
		case "4.019":
			if (global.ptr.bMixedUsage)
				value = global.ptr.subProp.propertyUseSummary?.nonResidentialUseDescription;
			break;
		case "4.020":
			value = global.ptr.subSite.propertyAccess.GetPrimaryEntryExitMethod();
			break;
		case "4.021":
			value = global.ptr.subSite.propertyAccess.GetStreetTypeAndSurface();
			break;
		case "4.022":
			var doIf = global.ptr.subSite.propertyAccess.propertyAccessDetail.propertyPrimaryEntryExitMethodType === "PrivateStreet";
			value = h.yesNoIf(global.ptr.subSite.propertyAccess.propertyAccessDetail.privateStreetMaintenanceAgreementExistIndicator, doIf);
			break;
		case "4.023":
			value = h.yesNo(global.ptr.subSite.propertyAccess.propertyAccessDetail.propertyAccessTypicalToMarketIndicator);
			break;
		case "4.024":
			value = global.ptr.subSite.propertyAccess.propertyAccessDetail.propertyAccessDescription;
			break;
		case "4.024-29":
			value = rf.SiteInfluencesList();
			//console.log("4.024-29: ", value);
			break;
		case "4.030":
			value = global.ptr.valRpt.GetValuationCommentaryText("SiteInfluences");
			break;
		case "4.031":
			value = global.ptr.subSite.GetWaterFrontageTotalLinearMeasurement();
			break;
		case "4.032":
			value = global.ptr.subSite.GetWaterFrontFeatures();
			break;
		case "4.033":
			value = "";
			if (!global.ptr.subSite.HasWaterFrontFeatures())
				value = h.yesNo(global.ptr.subSite.waterfrontDevelopmentRightsIndicator);
			break;
		case "4.034-37":
			value = [];
			var pa = global.ptr.subSite.GetPrivateAccess();
			if (pa.length > 0)
      for (var inf of pa)
				for (var bow of inf.bodiesOfWater.bodyOfWaterList) {
					var row =[];
					row.push(bow.GetBodyType());
					row.push(bow.bodyOfWaterName);
					row.push(bow.GetAccessType());
					row.push(bow.GetDepthType());
					value.push(row);
				}
			break;
		case "4.038":
			value = global.ptr.valRpt.GetValuationCommentaryText("WaterFrontages");
			break;
		case "4.039-41":
			value = rf.ViewAndImpactList();
			break;
		case "4.042":
			value = global.ptr.valRpt.GetValuationCommentaryText("SiteViews");
			break;
		case "4.043-65":
			value = rf.SiteFeaturesImpactList();
			//console.log("4.043-65: ", value);
			break;
		case "4.066":
			value = global.ptr.valRpt.GetValuationCommentaryText("SiteFeatures");
			break;
		case "4.067":
			value = h.yesNo(global.ptr.siteDetail.broadbandInternetAvailableIndicator ?? false);
			break;
		case "4.068":
			value = "";
			if (!global.ptr.bGovAgency) break;
			value = "N";
			var eases = global.ptr.subProp.GetEasementsByType("Utility");
			for (var ease of eases)
			 if (ease.improvementInBoundaryOfEasementIndicator ?? false)
				value = "Y";
			break;
		case "4.069-98":
			value = rf.GetUtilitiesImpactList();
			break;

		case "4.099":
			value = rf.SiteDefectsList();
			break;

		case "4.105":
			//console.log(global.ptr.valRpt.approachToValue);
			value = h.amountOrEmpty(global.ptr.valRpt.approachToValue.costApproach.costApproachDetail?.siteEstimatedValueAmount);
			break;
		case "4.106":
			value = global.ptr.valRpt.approachToValue.costApproach.GetValuationMethodType();
			break;
		case "4.107-114":
			value = rf.SiteValuationMethodologyList();
			//console.log("4.107-114", value);
			break;
		case "4.115":
			value = global.ptr.valRpt.approachToValue.costApproach.costApproachDetail?.siteEstimatedValueCommentDescription;
			break;
		case "4.116":
			value = global.ptr.valRpt.GetValuationCommentaryText("Site");
			break;
		case "5.000":
			value = global.ptr.subProp.GetDisasterMitigationFeaturesList();
			if (value.length === 1 && value[0] === "None")
				value = "None";
			break;
		case "5.001":
			value = global.ptr.valRpt.GetValuationCommentaryText("DisasterMitigation");
			break;
		case "6.000":
			value = global.ptr.subProp.energyEfficiencyAndGreen.GetRenewableEnergyComponentExists() ? "" : "None";
			break;
		case "6.001-3":
			value = [];
			if (global.ptr.subProp.energyEfficiencyAndGreen.GetRenewableEnergyComponentExists()) {
				for (var comp of global.ptr.subProp.energyEfficiencyAndGreen.renewableEnergyComponents) {
					row = [];
					row.push(comp.GetComponentType());
					row.push(comp.GetOwnershipType());
					row.push(comp.GetFinancing());
					value.push(row);
				}
			}
			break;
		case "6.004":
			value = global.ptr.subProp.energyEfficiencyAndGreen.GetGreenCertificationExists() ? "" : "None";
			break;
		case "6.005-9":
			value = [];
			if (global.ptr.subProp.energyEfficiencyAndGreen.GetGreenCertificationExists()) {
				for (var cert of global.ptr.subProp.energyEfficiencyAndGreen.greenBuildingCertifications)
				{
					row = [];
					row.push(cert.greenCertificationAssociationName);
					row.push(cert.greenCertificationName);
					row.push(cert.greenCertificationLevelAwardedYear);
					row.push(cert.greenCertificationVersionIdentifier);
					row.push(cert.greenCertificationLevelName);
					value.push(row);
				}
			}
			break;
		case "6.010":
			value  = global.ptr.subProp.energyEfficiencyAndGreen.GetEfficiencyRatingExists() ? "" : "None"
			break;
		case "6.011-13":
			value = [];
			if (global.ptr.subProp.energyEfficiencyAndGreen.GetEfficiencyRatingExists()) {
			for (var rating of global.ptr.subProp.energyEfficiencyAndGreen.greenEfficiencyRatings) {
				row = [];
				row.push(rating.efficiencyRatingOrganizationName);
				row.push(rating.efficiencyRatingName);
				row.push(rating.efficiencyRatingScoreValue);
				value.push(row);
				}
			}
			break;
		case "6.014":
			value = global.ptr.subProp.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail.valueMarketabilityImpactType;
			break;
		case "6.015":
			value = global.ptr.subProp.energyEfficiencyAndGreen.energyEfficiencyAndGreenDetail.energyEfficientAndGreenDescription
			break;
		case "6.016":
			value = global.ptr.valRpt.GetValuationCommentaryText("EnergyEfficientAndGreenFeatures");
			break;
		case "6.017.1|16.017.2":
			break;
		case "7.000":
			if (global.ptr.valDetail.sketchExistsIndicator)
				value = "";
			else
				value = "Sketch or Floor Plan Not Available";
			//console.log(`value: |${value}|`)
			break;
		case "7.001":
			value = global.ptr.valRpt.GetMeasurementStandardType();
			break;
		case "7.003":
			value = global.ptr.valRpt.GetValuationCommentaryText("Sketch");
			break;
		case "8.000":
			break;
		case "8.001":
			value = global.ptr.stDetail.livingUnitCount.toString();
		 	break;
		case "8.002":
			value = global.ptr.structure.GetStructuralDesignType();
		 	break;
		case "8.003":
			//StoriesCount
			value = global.ptr.stDetail.storiesCount?.toString();
			break;
		case "8.004":
			//ArchitecturalDesignCategoryType
			//if (attachment.Equals("Attached") && dwelling.ImprovementType.Equals("Dwelling"))
			value = global.ptr.structure.GetArchitecturalDesignType();
			break;
		case "8.005":
		 	value = h.toEnumText(global.ptr.stDetail.frontDoorApproximateElevationRangeType);
		 	break;
		case "8.006":
			value = h.yesNo(global.ptr.stDetail.rowhouseTownhouseEndUnitIndicator);
			break;
		case "8.007":
			value = h.yesNo(global.ptr.stDetail.rowhouseTownhouseBackToBackIndicator);
			break;
		case "8.008":
			value = h.yesNo(global.ptr.stDetail.rowhouseTownhouseStackedIndicator);
			break;
		case "8.009":
			value = h.toEnumText(global.ptr.stDetail.rowhouseTownhouseLocationType);
			break;
		case "8.010":
			value = dwelling.GetYearBuilt();
			//PropertyStructureBuiltYear
			//PropertyStructureBuiltYearEstimatedIndicator
			break;
		case "8.011":
			value = global.ptr.structure.GetConstructionMethodsList();
			//ConstructionMethodType
			break;
		case "8.012":
			value = (dwDetail.convertedAreaExistsIndicator ?? false) ? "" : "None";
			//ConvertedAreaExistsIndicator
			break;
		case "8.013":
			value = dwelling.GetConvertedAreaSimilarityList();
			//ConvertedAreaOriginalUseType
			//ConvertedAreaFinishComparisonType
			break;
		case "8.014":
				if (dwelling.structure.GetConstructionMethods().includes("Modular"))
					value = h.yesNo(dwelling.structure.factoryBuiltCertificationExaminedIndicator);
				else
					value = "";
			break;
		case "8.015":
			value = global.ptr.stDetail.structureVolumeMeasure.ToString();
			break;
		case "8.016":
			var windows = dwelling.structure.GetStructureComponent("Windows");
			if (windows !== null)
				value = windows.structureComponentDetail.windowSurfaceAreaMeasure.ToString();
			//WindowSurfaceAreaMeasure
			break;
		case "8.017":
			value = rf.DwellingExteriorAttic(dwelling);
			break;
		case "8.018":
			if (global.ptr.bGovAgency && !global.ptr.bCostApproach)
				value = global.ptr.structure.structureAnalysis?.structureAnalysisDetail.estimatedRemainingEconomicLifeYearsCount.toString();
			if (!value) value = "";
		// 	EstimatedRemainingEconomicLifeYearsCount
		 	break;
		case "8.019":
			if (global.ptr.bGovAgency && !global.ptr.bCostApproach)
				value = global.ptr.structure.GetEffectiveAge();
			if (!value) value = "";
		// 	EffectiveAgeYearsCount
		// 	EffectiveAgeRangeLowYearsCount
		// 	EffectiveAgeRangeHighYearsCount
			break;
		case "8.020":
			value = global.ptr.structure.GetRemainingLifeComment();
		// 	EstimatedRemainingEconomicLifeDescription
			break;
		case "8.021":
			value = global.ptr.structure.structureAnalysis?.structureAnalysisDetail.effectiveAgeDescription;
			if (!value) value = "";
		// 	EffectiveAgeDescription
			break;
		case "8.022":
			value = global.ptr.stDetail.exteriorQualityRatingCode;
			break;
		case "8.023":
			value = global.ptr.stDetail.exteriorConditionRatingCode;
			break;
		case "8.025-45":
			value = global.ptr.structure.GetFeatures();
			break;
		case "8.046":
			value = dwDetail.nonContinuousFinishedAreaIndicator ?? false;
			break;
		case "8.047-48":
			value = [];
			if (!(dwDetail.nonContinuousFinishedAreaIndicator ?? false)) return value;
			var summary = dwelling.GetNonContinuousRoomSummary();
			var finishedMeasure = dwelling.structure.structureDetail.structureNonContinuousFinishedAreaMeasure.ToString();
			row = [];
			row.push("Finished");
			row.push(finishedMeasure);
			row.push(summary);
			value.push(row);
			break;
		case "8.049-51":
			value = rf.MechanicalSystemDetails(dwelling);
			break;
		case "8.052":
			var he = global.ptr.subImprov.GetHasHeatingSystem();
			value = h.yesNoIf(dwelling.system.systemDetail?.coreHeatingSystemBelowGradeIndicator, he);
			//console.log("52: ", he, value);
			break;
		case "8.053":
			value = [];
			if (dwelling.system.mechanicalSystems.length === 0) break;
			for (var ms of dwelling.system.mechanicalSystems) {
				value.push(ms.GetSystemType());
			}
			break;
		case "8.056-60":
			value = rf.ImprovementDefectsList(dwelling);
			//console.log("8.056-8.060", value);
			break;
		case "8.061":
			value = dwelling.structure.structureDetail.structureValuationCommentText;
			break;
		case "8.099":
			value = rf.DwellingExteriorExhibits(dwelling);
			break;

		case "9.000":
			value = mhDetail.manufacturedHomeManufacturerName;
			break;
		case "9.001":
			value = mhDetail.manufacturedHomeInstalledDate.FormatMDY();
			break;
		case "9.002":
			value = h.yesNo(mhDetail.manufacturedHomeMovedAfterOriginalInstallationIndicator);
			break;
		case "9.003":
			value = h.yesNo(mhDetail.manufacturedHomeAttachedToFoundationIndicator);
			break;
		case "9.004":
			value = h.yesNo(mhDetail.manufacturedHomeHitchWheelsAxlesRemovedIndicator);
			break;
		case "9.005":
			value = h.toEnumText(mhDetail.manufacturedHomeWidthType);
			break;
		case "9.006":
			value = mh.GetSkirting();
			break;
		case "9.007":
			value = h.yesNo(mhDetail.manufacturedHomeModificationIndicator ?? false);
			break;
		case "9.008":
			value = mh.GetModificationTypes();
			break;
		case "9.009":
			value = mhDetail.manufacturedHomeModificationsDescription;
			break;
		case "9.010":
			value = h.yesNo(mhDetail.manufacturedHomeHUDDataPlateAttachedIndicator);
			break;
		case "9.011":
			value = mhDetail.manufacturedHomeManufactureDate.FormatMDY();
			break;
		case "9.012":
			value = mhDetail.manufacturedHomeSerialNumberIdentifier.replace("/", " ");
			break;
		case "9.013":
			value = h.toEnumText(mhDetail.windZoneCode);
			break;
		case "9.014":
			value = h.toEnumText(mhDetail.thermalZoneCode);
			break;
		case "9.015":
			value = h.toEnumText(mhDetail.roofLoadZoneCode);
			break;
		case "9.016":
			value = h.yesNo(mhDetail.manufacturedHomeHUDCertificateLabelIndicator);
			break;
		case "9.017":
			value = mh.GetCertificationNumbers();
			break;
		case "9.018-19":
			value = [];
			var certs = mh.GetFinancingEligibility();
			if (certs.length > 0) 
			{
				row = [];
				for (var item of certs) {
					row.push(item[0]);
					row.push(item[1]);
				}
				value.push(row);
			}
			break;
		case "9.020":
			value = h.yesNo(mhDetail.manufacturedHomePurchasedFromRetailerIndicator);
			break;
		case "9.021":
			value = mhDetail.manufacturedHomeRetailerName;
			break;
		case "9.022":
			value = h.yesNo(mhDetail.manufacturedHomeRetailerInvoiceReviewedIndicator);
			break;
		case "9.023":
			value = h.yesNo(mhDetail.manufacturedHomeInvoiceReviewedIndicator);
			break;
		case "9.024":
			value = h.yesNo(mhDetail.manufacturedHomeInvoiceReasonableIndicator);
			break;
		case "9.025":
			value = mhDetail.manufacturedHomeInvoiceNotReasonableDescription;
			break;
		case "9.026":
			value = mhDetail.manufacturedHomeValuationCommentText;
			break;

		case "10.003":
			//console.log("unitArea: ", unitArea);
			value = unitArea.unitStandardAboveGradeFinishedAreaMeasure.ToString();
			break;
		case "10.004":
			var area = unitArea.unitNonStandardAboveGradeFinishedAreaMeasure;
			value = area.HasNonZeroValue() ? area.ToString() : "";
			break;
		case "10.005":
			value = unitArea.unitAboveGradeUnfinishedAreaMeasure.ToString();
			break;
		case "10.006":
			value = unitArea.unitStandardBelowGradeFinishedAreaMeasure.ToString();
			break;
		case "10.007":
			var area = unitArea.unitNonStandardBelowGradeFinishedAreaMeasure;
			value = area.HasNonZeroValue() ? area.ToString() : "";
			break;
		case "10.008":
			value = unitArea.unitBelowGradeUnfinishedAreaMeasure.ToString();
			break;
		case "10.009":
			value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_PROPERTY_UNIT_AREA", unitArea.label);
			break;
		case "10.010":
			value = h.toEnumText(unitDetail.unitBelowGradeFinishComparisonType);
			break;
		case "10.011":
			value = h.yesNo(unitDetail.accessoryDwellingUnitIndicator);
			break;
		case "10.012":
			value = h.yesNo(unitDetail.accessoryDwellingUnitLegallyRentableIndicator ?? false);
			break;
		case "10.013":
			value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_AccessoryDwellingUnitLegallyRentableIndicator", propertyUnit.propertyUnitDetail.accessoryDwellingUnitLegallyRentableIndicatorLabel);
			break;
		case "10.014":
			value = h.yesNo(unitDetail.aAccessoryDwellingUnitTypicalToMarketIndicator);
			break;
		case "10.015":
			value = h.toEnumText(unitDetail.accessType);
			break;
		case "10.016":
			value = h.yesNo(unitDetail.separatePostalAddressIndicator);
			break;
		case "10.017":
			value = propertyUnit.GetLevelCount();
			break;
		case "10.018":
			value = unitDetail.floorIdentifier;
			break;
		case "10.019":
			
			if (global.ptr.bIsRise)
				value = h.yesNo(unitDetail.cornerUnitIndicator);
			break;
		case "10.020":
			value = h.toEnumText(unitDetail.unitOccupancyType);
			break;
		case "10.021":
			value = h.yesNo(unitDetail.utilitiesMeteredSeparatelyIndicator);
			break;
		case "10.022":
			value = h.yesNo(unitDetail.unitUtilitiesOperatingIndicator);
			break;
		case "10.023":
			value = unitDetail.bedroomCount.toString();
			break;
		case "10.024":
			value = unitDetail.fullBathroomCount.toString();
			break;
		case "10.025":
			value = unitDetail.halfBathroomCount.toString();
			break;
		case "10.026":
			value = h.yesNo(unitDetail.unitMixedUsageIndicator);
			break;
		case "10.027":
			value = h.yesNo(unitDetail.allowableLiveWorkSpaceIndicator);
			break;
		case "10.028":
			value = unitArea.allowableWorkSpaceAreaMeasure.ToString();
			break;
		case "10.029-33":
			value = rf.LevelDetailList(propertyUnit);
			//console.log(value);
			break;
		case "10.034":
			value = unitDetail.interiorQualityRatingCode
			break;
		case "10.035":
			value = unitDetail.interiorConditionRatingCode
			break;
		case "10.036":

			break;
		case "10.037-42":
			value = rf.KitchenAndBathroomDetailsList(propertyUnit);
			break;
		case "10.043":
			value = unitDetail.overallBathroomsUpdateStatusType
			break;
		case "10.044-48":
			value = rf.InteriorFeaturesList(propertyUnit);
			break;
		case "10.049":
			var flooringComponent = propertyUnit.GetComponent("Flooring");
			value = h.toEnumText(flooringComponent.interiorComponentDetail.overallFlooringUpdateStatusType);
			break;
		case "10.050-51":
			value = rf.AccessibilityFeaturesList(propertyUnit);
			break;
		case "10.052":

			break;
		case "10.053":

			break;
		case "10.054":

			break;
		case "10.055":
			value = global.ptr.subImprovs.GetUnitDefectsExist();
			break;
		case "10.056-60":
			value = rf.UnitDefectsList(propertyUnit);
			//console.log("10.0xx: ", value);
			break;
		case "10.061":
			value = unitDetail.unitValuationCommentText;
			break;
		case "10.099":
			value = rf.UnitInteriorExhibitImages(propertyUnit);
			break;

		case "11.000":
			value = global.ptr.subProp.GetFunctionalIssues();
			break;
		case "11.001":
			value = global.ptr.subDetail.functionalIssueDescription;
			break;

		case "12.000":

			break;
		case "12.001":
			break;
		case "12.002":
			value = h.yesNo(global.ptr.outbuildingDetail.outbuildingRealPropertyIndicator);
			break;
		case "12.003":
			var luc = global.ptr.outbuilding.structure.structureDetail.livingUnitCount.toString();
			value = luc ? luc : "0";
			break;
		case "12.004":
			break;
		case "12.005":
			value = (global.ptr.outbuilding.structure.structureDetail.structureVolumeMeasure.ToString());
			break;
		case "12.006":
			value = (global.ptr.outbuilding.structure.structureDetail.structureAreaMeasure.ToString());
			break;
		case "12.007":

			break;
		case "12.008":
			value = global.ptr.outbuildingDetail.heatingSystemExistsIndicator ?? false;
			break;
		case "12.009":
			value = global.ptr.outbuildingDetail.coolingSystemExistsIndicator ?? false;
			break;
		case "12.010":
			value = global.ptr.outbuilding.outbuilding.GetUtilityList();
			break;
		case "12.011-13":
			value = rf.GetRoomSummariesList(global.ptr.outbuilding);
			break;
		case "12.014-16":
			value = rf.MechanicalSystemDetails(global.ptr.outbuilding);
			break;
		case "12.017":

			break;
		case "12.018":

			break;
		case "12.019":
			value = global.ptr.subImprovs.GetOutbuildingDefectsExist();
			break;
		case "12.020-24":
			value = rf.ImprovementDefectsList(global.ptr.outbuilding);
			break;
		case "12.099":
			value = rf.OutbuildingExhibits(dwelling);
			break;

		case "13.001-03":
			value = rf.VehicleStorageList();
			break;
		case "13.004":
			value = global.ptr.subDetail.vehicleStorageDefectsExistIndicator ?? false;
			break;
		case "13.005-09":

			break;
		case "13.010":
			value = global.ptr.valRpt.GetValuationCommentaryText("VehicleStorage");
			break;
		case "13.099":
			value = rf.VehicleStorageExhibits();
			break;

		case "14.001-04":
			value = rf.AmenitiesList();
			//console.log("amen: ", value);
			break;
		case "14.005":
			value = global.ptr.subDetail.subjectPropertyAmenitiesDefectsExistIndicator ?? false;
			break;
		case "14.006-10":
			value = rf.AmenitiesDefectsRowsList();
			//console.log("14.000:", value);
			break;
		case "14.011":
			value = global.ptr.valRpt.GetValuationCommentaryText("SubjectPropertyAmenities");
			break;
		case "14.099":
			value = rf.SubjectPropertyAmenityExhibits();
			break;

		case "15.000":
			value = global.ptr.subDetail.overallQualityRatingCode;
			break;
		case "15.001":
			value = rf.OverallQualityList();
			break;
		case "15.005":
			value = global.ptr.subDetail.overallConditionRatingCode;
			break;
		case "15.006":
			value = rf.OverallConditionList();
			break;
		case "15.010":
			value = global.ptr.valRpt.GetValuationCommentaryText("OverallQualityAndCondition");
			break;

		case "16.000":
			value = h.yesNo(global.ptr.subSite.highestAndBestUse.legallyPermissibleIndicator);
			break;
		case "16.001":
			value = h.yesNo(global.ptr.subSite.highestAndBestUse.physicallyPossibleIndicator);
			break;
		case "16.002":
			value = h.yesNo(global.ptr.subSite.highestAndBestUse.financiallyFeasibleIndicator);
			break;
		case "16.003":
			value = h.yesNo(global.ptr.subSite.highestAndBestUse.maximallyProductiveIndicator);
			break;
		case "16.004":
			value = global.ptr.subSite.highestAndBestUse.siteHighestBestUseIndicator;
			break;
		case "16.005":
			value = global.ptr.valRpt.GetValuationCommentaryText("HighestAndBestUse");
			break;

		case "17.003":
			value = global.ptr.subProp.market.marketDetail.marketBoundariesDescription;
			break;
		case "17.004":
			value = global.ptr.subProp.market.marketDetail.marketInventorySearchParameterDescription;
			break;
		case "17.005":
			var al = global.ptr.subProp.market.GetMarketInventory("ActiveListings");
			value = al.marketInventoryCount.toString();
			break;
		case "17.006":
			al = global.ptr.subProp.market.GetMarketInventory("ActiveListings");
			value = al.marketInventoryMedianDaysOnMarketCount.toString();
			break;
		case "17.007":
			al = global.ptr.subProp.market.GetMarketInventory("ActiveListings");
			value = h.amountOrEmpty(al.marketInventoryLowestPriceAmount);
			break;
		case "17.008":
			al = global.ptr.subProp.market.GetMarketInventory("ActiveListings");
			value = h.amountOrEmpty(al.marketInventoryMedianPriceAmount);
			break;
		case "17.009":
			al = global.ptr.subProp.market.GetMarketInventory("ActiveListings");
			value = h.amountOrEmpty(al.marketInventoryHighestPriceAmount);
			break;
		case "17.010":
			var ps = global.ptr.subProp.market.GetMarketInventory("PendingSales");
			value = ps ? ps.marketInventoryCount.toString() : "0";
			break;
		case "17.011":
			value = global.ptr.subProp.market.marketDetail.marketInventoryLookbackMonthsCount.toString();
			break;
		case "17.012":
			var mi = global.ptr.subProp.market.GetMarketInventory("TotalSales");
			value = mi.marketInventoryCount.toString();
			//console.log(value, mi);
			break;
		case "17.013":
			mi = global.ptr.subProp.market.GetMarketInventory("TotalSales");
			value = h.amountOrEmpty(mi.marketInventoryLowestPriceAmount);
			break;
		case "17.014":
			mi = global.ptr.subProp.market.GetMarketInventory("TotalSales");
			value = h.amountOrEmpty(mi.marketInventoryMedianPriceAmount)
			break;
		case "17.015":
			mi = global.ptr.subProp.market.GetMarketInventory("TotalSales");
			value = h.amountOrEmpty(mi.marketInventoryHighestPriceAmount);
			break;
		case "17.016":
			value = h.yesNo(global.ptr.subProp.market.marketTrend.marketTrendsForeclosureActivityIndicator);
			break;
		case "17.017":
			value = global.ptr.subProp.GetGraphImagesDescriptions();
			break;
		case "17.018":
			value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_MARKET_TREND", global.ptr.subProp.market.marketTrend.label);
			break;
		case "17.019":
			value = global.ptr.subProp.market.marketTrend.priceTrendsAnalysisDescription;
			break;
		case "17.020":
			
			break;
		case "17.021":
			value = h.toEnumText(global.ptr.subProp.market.marketTrend.marketSupplyTrendType);
			break;
		case "17.022":
			value = h.toEnumText(global.ptr.subProp.market.marketTrend.marketingTimeType);
			break;
		case "17.023":
			value = global.ptr.valRpt.GetValuationCommentaryText("Market");
			break;
		case "17.099":
			value = rf.MarketAnalysisExhibits();
			break;

		case "18.000":
			value = global.ptr.bPUD;
			break;
		case "18.001":
			value = global.ptr.bCondominium;
			break;
		case "18.002":
			value = global.ptr.bCooperative;
			break;
		case "18.003":
			value = global.ptr.bCondop;
			break;
		case "18.004":
			value = global.ptr.subProj.projectDetail.projectName;
			break;
		case "18.005":
			value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_PROJECT", global.ptr.subProj.label);
		break;
		case "18.006":
			value = global.ptr.subProj.projectDetail.projectDwellingUnitCount?.toString();
			break;
		case "18.007":
			value = global.ptr.subProj.projectDetail.projectDwellingUnitsSoldCount?.toString();
			break;
		case "18.008":
			value = global.ptr.subProj.projectDetail.projectDwellingUnitsForSaleCount?.toString();
			break;
		case "18.009":
			value = global.ptr.subProj.projectDetail.projectDwellingUnitsRentedCount?.toString();
			if (global.ptr.subProj.projectDetail.projectDwellingUnitsRentedEstimateIndicator)
				value = "~" + value;

			break;
		case "18.010":
			value = global.ptr.subProj.projectDetail.projectDwellingUnitsRentedEstimateDescription;
			break;
		case "18.011":
			//console.log(global.ptr.subProp);
			var ac = global.ptr.subProp.homeownersAssociations.GetAssociationCharges("AssociationDues");
			value = (ac.length > 0) ? h.amountOrEmpty(ac[0].associationChargeDetail.associationChargeAmount) : "";
			break;
		case "18.012":
			value = global.ptr.subProj.GetAmenitiesList();
			break;
		case "18.013":
			var ac = global.ptr.subProp.homeownersAssociations.GetAssociationCharges("AssociationDues");
			value = (ac.length > 0) ? ac[0].GetUtilitesIncludedList() : "";
			break;
		case "18.014":
			value = global.ptr.subProj.projectAnalysis.projectDeficiencyObservedIndicator;
			break;
		case "18.015":
			value = global.ptr.subProj.projectAnalysis.projectConditionAndQualityDescription;
			break;
		case "18.016":
			value = global.ptr.subProj.projectDetail?.projectCompletedIndicator;
			break;
		case "18.017":
			if (global.ptr.subProj.projectDetail.projectCompletedIndicator)
				value = global.ptr.subProj.projectDetail.subjectBuildingCompletedIndicator;
			break;
		case "18.018":
			value = global.ptr.subProj.projectConversion.projectConversionIndicator ?? false;
			break;
		case "18.019":
			value = global.ptr.subProj.projectAnalysis.projectAnalysisGroundRentIndicator;
			break;
		case "18.020":
			value = h.amountOrEmpty(global.ptr.subProj.projectAnalysis.projectAnalysisGroundRentAmount);
			break;
		case "18.021":
			value = global.ptr.subProj.projectAnalysis.projectAnalysisGroundRentExpirationDate.FormatMDY();
			break;
		case "18.022":
			value = global.ptr.subProj.projectAnalysis.projectAnalysisGroundRentDescription;
			break;
		case "18.023":
			value = global.ptr.subProj.projectFinancialInformation.projectTotalSharesIssuedAndOutstandingCount.toString();
			break;
		case "18.024":
			value = global.ptr.subDetail.propertyCooperativeSharesCount.toString();
			break;
		case "18.025":
			value = global.ptr.subDetail.cooperativeProprietaryLeaseExpirationDate.FormatMDY();
			break;
		case "18.026":
			value = global.ptr.subProj.projectFinancialInformation.projectBlanketFinancingIndicator;
			break;
		case "18.027":
			value = global.ptr.subDetail.proRataSharePercent;
			if (value) value += "%";
			break;
		case "18.028":
			value = rf.GetProjectFinancingTitles();
			break;
		case "18.029-63":
			value = rf.GetProjectFinancing();
			break;
		case "18.064-93":
			value = rf.ProjectFactorsList();
			break;
		case "18.094":
			value = global.ptr.valRpt.GetValuationCommentaryText("ProjectFactors");			
			break;
		case "18.095":
			value = global.ptr.valRpt.GetValuationCommentaryText("Project");			
			break;

		case "19.000":
			value = h.yesNone(global.ptr.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false);
			break;
		case "19.001":
			var listSum = global.ptr.subProp.listingInformationSummary;
			if (!listSum.listedWithinPreviousYearIndicator)
				value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_LISTING_INFORMATION_SUMMARY", listSum.label);
			break;
		case "19.002-09":
			value = rf.ListingInformationList();
			break;
		case "19.010":
			value = rf.ListingInformationDOMTotal();
			break;
		case "19.011":
			value = global.ptr.valRpt.GetValuationCommentaryText("SubjectListing");			
			break;

		case "20.000":
			value = global.ptr.subSales.salesContracts[0].salesContractDetail.salesContractExistsIndicator;
			break;
		case "20.001":
			value = global.ptr.subSales.salesContracts[0].salesContractDetail.salesContractReviewedIndicator;
			break;
		case "20.002":
			value = global.ptr.subSales.salesContracts[0].salesContractDetail.armsLengthIndicator;
			break;
		case "20.003":
			value = global.ptr.subSales.salesContracts[0].salesContractDetail.nonArmsLengthCommentText;
			break;
		case "20.004":
			value = h.amountOrEmpty(global.ptr.subSales.GetContractAmount());
			break;
		case "20.005":
			value = global.ptr.subSales.salesContracts[0].salesContractDetail.salesContractDate.FormatMDY();
			break;
		case "20.006":
			value = global.ptr.subSales.salesContracts[0].GetSaleType();
			break;
		case "20.007":
			value = h.yesNo(global.ptr.subSales.salesContracts[0].salesContractDetail.personalPropertyIncludedIndicator);
			break;
		case "20.008":
			value = h.yesUnknown(global.ptr.subSales.salesContracts[0].salesContractDetail.salesConcessionIndicator);
			break;
		case "20.009":
			value = h.amountOrEmpty(global.ptr.subSales.salesContracts[0].salesContractDetail.totalSalesConcessionAmount);
			break;
		case "20.010":
			value = h.yesNo(global.ptr.subSales.salesContracts[0].salesContractDetail.salesConcessionsTypicalToMarketIndicator);
			break;
		case "20.011":
			value = global.ptr.valRpt.GetValuationCommentaryText("SalesContract");			
			break;

		case "21.000":
			// only show NO value
			value = h.yesNone(global.ptr.subDetail.priorSalesOrTransfersIndicator);
			break;
		case "21.001":
			var label = global.ptr.subDetail.priorSalesOrTransfersLabel;
			value = rf.GetDataSourcesList("DATA_SOURCE_IsDataSourceFor_PriorSalesOrTransfersIndicator", label);
			break;
		case "21.002-05":
			value = rf.SubjectTransferHistoryList();
			break;
		case "21.006":
			value = global.ptr.valRpt.GetValuationCommentaryText("SubjectPriorSalesAndTransferHistory");
			break;
		case "21.007-11":
			value = rf.ComparableTransferHistoryList();
			break;
		case "21.012":
			value = global.ptr.valRpt.GetValuationCommentaryText("ComparablesPriorSalesAndTransferHistory");
			break;

		case "22.001":
			value = scf.GetSalesCompGeneralInformation();
			break;
		case "22.001.1":
			value = scf.GetCompAddresses();
			break;
		case "22.001.2":
			value = scf.GetCompImages();
			break;
		case "22.002":
			value = scf.GetSalesCompProjectInformation();
			break;
		case "22.003":
			value = scf.GetSalesCompSite();
			break;
		case "22.004":
			value = scf.GetSalesCompWaterFrontage();
			break;
		case "22.005":
			value = scf.GetSalesCompDwellings();
			break;
		case "22.006":
			value = scf.GetSalesCompEnergyEfficientAndGreenFeatures();
			break;
		case "22.007":
			value = scf.GetSalesCompUnits();
			break;
		case "22.008":

			break;
		case "22.009":
			value =  scf.GetSalesCompQCExteriorQC();
			break;
		case "22.010":
			value =  scf.GetSalesCompQCInteriorQC();
			break;
		case "22.011":
			value = scf.GetSalesCompQCADUInteriors();
			break;
		case "22.012":
			value = scf.GetSalesCompOverallQualityAndCondition();
			break;
		case "22.013":
			value = scf.GetSalesCompPropertyAmenities();
			break;
		case "22.014":
			value = scf.GetSalesCompVehicleStorage();
			break;
		case "22.015.0":
			// check if there are any outbuildings for this section
			value = (global.ptr.valuationAnalysis.GetMaxOutbuildings() > 0);
			break;
		case "22.015":
			value = scf.GetSalesCompOutbuildings();
			break;
		case "22.016":
			value = scf.GetSalesCompSummary();
			break;
		case "22.017":
			value = scf.GetSalesCompIndicatedValue();
			break;
		case "22.018":
			value = global.ptr.valRpt.approachToValue.salesComparisonApproach.salesComparisonApproachDetail.salesComparisonCommentDescription;
			break;
		case "22.019":
			value = scf.PropertiesAnalyzedNotUsedList();
			break;
		case "22.099":
			value = rf.SalesComparisonApproachExhibits();
			break;

		case "23.01.01-10":
			value = ri.SubjectPropertyRentalInformationList();
			break;
		case "23.01.11":
			value = global.ptr.bRentControl ? global.ptr.rentControlDescription : "";
			break;
		case "23.01.12-14":
			value = ri.RentalInfoActualIncomeRent();
			break;
		case "23.01.15-17":
			value = ri.RentalInfoActualIncomeOther();
			break;
		case "23.01.18.1":
			value = h.toDollarAmount(global.ptr.rentActualIncomeRentTotal);
			break;
		case "23.01.18.2":
			value = h.toDollarAmount(global.ptr.rentActualIncomeOtherTotal);
			break;
		case "23.01.18":
			value = h.toDollarAmount(global.ptr.rentActualIncomeRentTotal + global.ptr.rentActualIncomeOtherTotal);
			break;
		case "23.01.19-21":
			value = ri.RentalInfoOpinionOfIncomeRent();
			break;
		case "23.01.22-24":
			value = ri.RentalInfoOpinionOfIncomeOther();
			break;
		case "23.01.25.1":
			value = h.toDollarAmount(global.ptr.rentOpinionOfIncomeRentTotal);
			break;
		case "23.01.25.2":
			value = h.toDollarAmount(global.ptr.rentOpinionOfIncomeOtherTotal);
			break;
		case "23.01.25":
			value = h.toDollarAmount(global.ptr.rentOpinionOfIncomeRentTotal + global.ptr.rentOpinionOfIncomeOtherTotal);
			break;
		case "23.02.00":
			value = ri.ComparableRentalPropertiesImages();
			break;
		case "23.02.01":
			value = ri.ComparableRentalProperties();
			break;
		case "23.03.00":
			value = ri.ComparableRentalAnalysis();
			//console.log(value);
			break;
		case "23.099":
			value = ri.RentalInformationExhibits();
			break;

		case "24.010-21":
			value = iaf.GetSalesCompGeneralInformation();
			break;
		case "24.022":
			value = global.ptr.subProp.rentalInformationSummary.rentalInformationSummaryDetail.totalMonthlyMarketRentAmount.ToDollarAmount();
			break;
		case "24.023":
			value = global.ptr.approachToValue.incomeApproach.incomeApproachDetail.grossRentMultiplierFactorNumber.toString();
			break;
		case "24.024":
			value = global.ptr.approachToValue.incomeApproach.incomeApproachDetail.valueIndicatedByIncomeApproachAmount.ToDollarAmount();
			break;
		case "24.025":
			value = global.ptr.approachToValue.incomeApproach.incomeApproachDetail.incomeAnalysisCommentDescription;
			break;
		case "24.099":
			value = rf.IncomeApproachExhibits();
			break;

		case "25.000":
			value = global.ptr.costDetail.valueIndicatedByCostApproachAmount.ToDollarAmount();
			break;
		case "25.001":
			value = global.ptr.costDetail.depreciatedCostDwellingsTotalAmount.ToDollarAmount();
			break;
		case "25.002":
			value = global.ptr.costDetail.depreciatedCostOutbuildingsTotalAmount.ToDollarAmount();
			break;
		case "25.003":
			value = global.ptr.costDetail.siteOtherImprovementsAsIsAmount.ToDollarAmount();
			break;
		case "25.004":
			value = global.ptr.costDetail.siteEstimatedValueAmount.ToDollarAmount();
			break;
		case "25.005":
			value = dwelling.structure.structureDetail.structureIdentifier ?? "";
			break;
		case "25.006.1":
			value = caf.DepreciatedCost("Dwelling");
			//console.log(value);
			break;
		case "25.006.2":
			value = h.toDollarAmount(global.ptr.tempTotal);
			//console.log(value);
			break;
		case "25.006-17":
			value = caf.GetDepreciatedCost(dwelling);
			//console.log(value);
			break;
		case "25.018":
			break;
		case "25.019":
			value = dwelling.GetRemainingLifeYears();
			break;
		case "25.020":
			value = dwelling.structure.GetEffectiveAge();
			break;
		case "25.021":
			value = dwelling.structure.GetRemainingLifeComment();
			break;
		case "25.022":
			value = dwelling.structure.GetEffectiveAgeDescription();
			break;
		case "25.023":
			value = dwelling.GetOutbuildingType();
			break;
		case "25.024.1":
			value = caf.DepreciatedCost("Outbuilding");
			//console.log(value);
			break;
		case "25.024-35":
			value = caf.GetDepreciatedCost(dwelling);
			break;
		case "25.036":
			break;
		case "25.037.1":
			value = (global.ptr.costApproach.siteImprovementsAsIsCosts?.length ?? 0) > 0;
			break;
		case "25.037-38":
			value = caf.CostAsIsValues();
			//console.log(value);
			break;
		case "25.039":
			break;
		case "25.040":
			value = global.ptr.costApproach.GetValuationMethodType();
			break;
		case "25.041":
			value = global.ptr.costApproach.costApproachDetail.siteEstimatedValueAmount.ToDollarAmount();
			break;
		case "25.042-49":
			value = rf.SiteValuationMethodologyList();
			break;
		case "25.050":
			value = global.ptr.valRpt.approachToValue.costApproach.costApproachDetail?.siteEstimatedValueCommentDescription;
			break;
		case "25.051":
			value = global.ptr.costApproach.GetAnalysisType();
			break;
		case "25.052":
			value = caf.GetCostDataSource();
			break;
		case "25.053":
			value = caf.GetCostDataSourceQualityRating();
			break;
		case "25.054":
			value = caf.GetCostDataSourceEffectiveDate();
			break;
		case "25.055":
			value = global.ptr.costApproach.GetCostMethod();
			break;
		case "25.056":
			value = global.ptr.costApproach.GetDepreciationMethod();
			break;
		case "25.057":
			value = global.ptr.costApproach.costApproachDetail.costAnalysisCommentDescription;
			break;
		case "25.099":
			//value = rf.CostApproachExhibits();
			break;

		case "26.000-05":
			value = global.ptr.value = rf.ReconAPV();
			break;
		case "26.006":
			value = global.ptr.subSales.GetContractAmount().ToDollarAmount()
			break;
		case "26.007":
			value = global.ptr.valSumDetail.opinionOfValueAmount.ToDollarAmount();
			if (global.ptr.bCooperative || global.ptr.bCondop) value += " (Cooperative Interest)";
			break;
		case "26.008":
			value = h.toEnumText(global.ptr.valSumDetail.lineOfCreditProRataShareSelectionMethodType);
			break;
		case "26.009":
			value = global.ptr.valRecon.GetValuationConditionsList();
			break;
		case "26.010":
			value = global.ptr.valSum.GetExposureTime();
			break;
		case "26.011":
			value = global.ptr.valSumDetail.appraisalReportEffectiveDate.FormatMDY();
			break;
		case "26.012":
			value = h.toEnumText(global.ptr.valRecon.FHA_REOInsurabilityLevelCode);
			break;
		case "26.013":
			value = global.ptr.valRecon.GetFinalValueConditionStatement();
			break;
		case "26.014-17":
			value = rf.ClientRequestedConditionsList();
			break;
		case "26.018":
			value = global.ptr.valRecon.valuationReconciliationDetail.additionalClientRequestedConditionsCommentDescription;
			break;
		case "26.019":
			value = global.ptr.valRecon.valuationReconciliationDetail.valuationReconciliationSummaryCommentDescription;
			break;
		case "26.020":
			break;
		case "26.021-69":
			// this is a repeat for ADDD_SUMMARY and not used here
			break;
		case "26.070":
			break;
		case "26.071":
			value = global.ptr.valSumDetail.propertyAsIsConditionRatingCode;
			break;
		case "26.072":
			value = "";
			if ( global.ptr.subProp.GetCostToRepairType() === "TotalCost")
				value = h.amountOrEmpty(global.ptr.subProp.GetCostToRepairTotalAmount());
			break;

		case "27.000-02":
			value = rf.GetRevisionHistory();
			break;
		case "27.003":
			value = h.toEnumText(global.ptr.valRpt.reconsiderationsOfValue[0].reconsiderationOfValueRequestedByType);
			break;
		case "27.004":
			value = global.ptr.valRpt.reconsiderationsOfValue[0].reconsiderationOfValueResultDate.FormatMDY();
			break;
		case "27.005":
			value = h.toEnumText(global.ptr.valRpt.reconsiderationsOfValue[0].reconsiderationOfValueResultType);
			break;
		case "27.006":
			value = global.ptr.valRpt.reconsiderationsOfValue[0].reconsiderationOfValueCommentDescription;
			break;

		case "28.0":

		break;

		case "29.0":
			break;

		default:
			break;
	}
	} catch (err) {
		let msg = "Trap in lu(" + fId + "): " + err;
		console.log(msg);
		alert(msg);
		return undefined;
	}

	if (value === undefined) {
		//if (fId !== "") console.log("value: ", fId);
		//value = fId;
	}
	global.ptr.lookupValue = value;
	return value;
}

